import type { CountryConfigMap } from '../auth-config-types'

export const preproductionConfig: CountryConfigMap = {
	US: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '2816e68f-d202-4b18-9cc1-809160ffd363',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	UK: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/uk-en',
			urls: {
				MyAccountProfileURL: '/uk-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/uk-en',
			},
		},
	},
	CA: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '0e518cb7-2ad3-4fc7-98ef-8c84d9f0f7a7',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/en',
			urls: {
				MyAccountProfileURL: '/en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/en/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/en/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/en/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/en',
			},
		},
		fr: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '0e518cb7-2ad3-4fc7-98ef-8c84d9f0f7a7',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr',
			urls: {
				MyAccountProfileURL: '/fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/fr/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/fr/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/fr/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin + '/fr',
			},
		},
	},
	MX: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapPolicy: 'B2C_1A_SeamlessMigration_SignUpOrSignIn',
			mapClientId: '94725b86-50ea-4b9b-8a42-a39febb9259f',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
	BR: {
		pt: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '5c9423ac-70c6-4a87-8582-b4e0d8b0685d',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin,
			},
		},
	},
	AR: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'b856ffb9-95b7-42cf-81d2-ab2eb1c5deeb',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CL: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '1bea0634-968c-4f9f-9075-e903a3da4417',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CO: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '39cf3d1f-dd26-495b-8da3-f38926ad8412',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	EC: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '95a3cb77-9bc7-4116-916a-8f672766d05e',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	PY: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'a3a0617f-8c24-48eb-a80e-eff5dd102de8',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	PE: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: 'f2caa41a-9027-45a7-be5b-d10c51b17352',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	UY: {
		es: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_GMSA_SIGNUPORSIGNIN',
			mapClientId: '436adcdd-6dcc-47f1-b2fa-3f209ebb93ee',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/bypass/apim/global-nav/loyalty/points',
				rewardsUseLoyaltyHeaders: true,
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/',
			},
		},
	},
	CH: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-en',
			urls: {
				MyAccountProfileURL: '/ch-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-en',
			},
		},
		fr: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-fr',
			urls: {
				MyAccountProfileURL: '/ch-fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-fr',
			},
		},
		de: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ch-de',
			urls: {
				MyAccountProfileURL: '/ch-de/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ch-de',
			},
		},
	},
	DE: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/de-en',
			urls: {
				MyAccountProfileURL: '/de-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/de-en',
			},
		},
		de: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/de-de',
			urls: {
				MyAccountProfileURL: '/de-de/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/de-de',
			},
		},
	},
	EU: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/eu-en',
			urls: {
				MyAccountProfileURL: '/eu-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/eu-en',
			},
		},
	},
	FR: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr-en',
			urls: {
				MyAccountProfileURL: '/fr-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/fr-en',
			},
		},
		fr: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/fr-fr',
			urls: {
				MyAccountProfileURL: '/fr-fr/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/fr-fr',
			},
		},
	},
	SE: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/se-en',
			urls: {
				MyAccountProfileURL: '/se-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/se-en',
			},
		},
		sv: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/se-sv',
			urls: {
				MyAccountProfileURL: '/se-sv/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/se-sv',
			},
		},
	},
	KR: {
		ko: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/b2c_1a_sk_seamlessmigration_signuporsignin',
			mapPolicy: 'b2c_1a_sk_seamlessmigration_signuporsignin',
			mapClientId: 'c28ada13-0014-4ff3-9614-308c9a98be46',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				KoreanProfileRefreshURL: '/bypass/korea/quantum/member/login-refresh.gm',
				KoreanCheckJsonURL: '/bypass/korea/quantum/member/ChkLoginJson.gm',
				logoutURL: location.origin,
			},
		},
	},
	JP: {
		ja: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5d2668e0-65ae-475c-ab3e-518aba72d487',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/',
			urls: {
				MyAccountProfileURL: '/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '/api/_gbpe/v3/rewards',
				MyAccountVehicleURL: '/ownercenter/api/garagesummary',
				MyAccountMissingInfoURL: '/ownercenter/api/checkMissingInfo',
				NotificationInboxURL: '/notif/delivery/inbox/v1/customer',
				logoutURL: location.origin,
			},
		},
	},
	NZ: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5d2668e0-65ae-475c-ab3e-518aba72d487',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/nz-en',
			urls: {
				MyAccountProfileURL: '/nz-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/nz-en',
			},
		},
	},
	AU: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority: 'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_ANZ_SIGNUPORSIGNIN',
			mapClientId: '5d2668e0-65ae-475c-ab3e-518aba72d487',
			mapAuthScopes: ['openid', 'profile'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/au-en',
			urls: {
				MyAccountProfileURL: '/au-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/au-en',
			},
		},
	},
	NO: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/no-en',
			urls: {
				MyAccountProfileURL: '/no-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/no-en',
			},
		},
		no: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/no-no',
			urls: {
				MyAccountProfileURL: '/no-no/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/no-no',
			},
		},
	},
	GB: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/gb-en',
			urls: {
				MyAccountProfileURL: '/gb-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/gb-en',
			},
		},
	},
	IE: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_EU_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31',
			mapAuthScopes: ['openid', 'profile', 'cb0c5ea3-f76f-4c3b-aaa5-3467caa50b31'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ie-en',
			urls: {
				MyAccountProfileURL: '/ie-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ie-en',
			},
		},
	},
	OM: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/om-en',
			urls: {
				MyAccountProfileURL: '/om-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/om-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/om-ar',
			urls: {
				MyAccountProfileURL: '/om-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/om-ar',
			},
		},
	},
	BH: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/bh-en',
			urls: {
				MyAccountProfileURL: '/bh-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/bh-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/bh-ar',
			urls: {
				MyAccountProfileURL: '/bh-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/bh-ar',
			},
		},
	},
	SA: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/sa-en',
			urls: {
				MyAccountProfileURL: '/sa-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/sa-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/sa-ar',
			urls: {
				MyAccountProfileURL: '/sa-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/sa-ar',
			},
		},
	},
	QA: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/qa-en',
			urls: {
				MyAccountProfileURL: '/qa-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/qa-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/qa-ar',
			urls: {
				MyAccountProfileURL: '/qa-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/qa-ar',
			},
		},
	},
	KW: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/kw-en',
			urls: {
				MyAccountProfileURL: '/kw-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/kw-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/kw-ar',
			urls: {
				MyAccountProfileURL: '/kw-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/kw-ar',
			},
		},
	},
	AE: {
		en: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ae-en',
			urls: {
				MyAccountProfileURL: '/ae-en/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ae-en',
			},
		},
		ar: {
			mapTenant: 'custlogin.pp.gm.com',
			mapAuthority:
				'https://custlogin.pp.gm.com/gmb2ctest.onmicrosoft.com/B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapPolicy: 'B2C_1A_MEO_SEAMLESSMIGRATION_SIGNUPORSIGNIN',
			mapClientId: '479af317-59ba-4a56-92f5-9d24602fd158',
			mapAuthScopes: ['openid', 'profile', '479af317-59ba-4a56-92f5-9d24602fd158'],
			mapApprovedAuthorities: ['custlogin.pp.gm.com'],
			mapRedirectURI: '/',
			mapPostLogoutRedirectURI: '/ae-ar',
			urls: {
				MyAccountProfileURL: '/ae-ar/api/_gbpe/v3/profiles',
				MyAccountRewardsURL: '',
				MyAccountVehicleURL: '',
				MyAccountMissingInfoURL: '',
				NotificationInboxURL: '',
				logoutURL: location.origin + '/ae-ar',
			},
		},
	},
}
